export type Prerender = {
  isPrerendering: boolean
};

export function usePrerender(): Prerender {
  return { isPrerendering: (typeof window == "undefined") }
}

